// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Do-z","imageAndVideoCount":"Eo-z","imageAndVideoContainer":"Fo-z","viewAllReviews":"Go-z"};